import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useMemo } from 'react';

import { Spinner } from '@/components/common/Spinner';
import { SelectOptionProps } from '@/models/SelectOption';
import { UserType } from '@/models/User';

type Props = {
  userType: UserType | null | undefined;
  value: number | null;
  options: SelectOptionProps[] | null;
  loading: boolean;
  onChange: (id: number | null) => void;
};

export default function ContactSelectField({ userType, value, options, loading, onChange }: Props) {
  const fieldDisabled = useMemo(
    () => userType !== UserType.Adf || loading || options === null || options.length === 0,
    [userType, loading, options]
  );

  return (
    <FormControl fullWidth>
      <InputLabel id='login-contact-label'>Login Contact</InputLabel>
      <Select
        labelId='login-contact-label'
        label='Login Contact'
        MenuProps={{ PaperProps: { sx: { maxHeight: 300, maxWidth: 460 } } }}
        value={value !== null ? value.toString() : ''}
        onChange={(e: SelectChangeEvent) => onChange(Number(e.target.value))}
        disabled={fieldDisabled}
        endAdornment={
          fieldDisabled ? (
            <Box marginRight={2}>
              <Spinner type='circular' size={18} />
            </Box>
          ) : undefined
        }
      >
        {options?.map((c) => (
          <MenuItem key={c.value} value={c.value}>
            {c.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
